import React, { useState, useContext, useEffect, Fragment } from "react";
import { useParams, useNavigate, Link } from "react-router-dom"; // > V5.1
import {
  Descriptions,
  Image,
  Progress,
  Row,
  Col,
  Typography,
  Breadcrumb,
  Button,
  Rate,
} from "antd";
import {
  toFirstCharUpperCase,
  ageCalculator,
  getNameInitials,
  constructFullName,
  getTextOfServiceProvider,
} from "../../../utils/helpers";
import "../DetailServiceProvider/DetailServiceProvider.css";
import { ServiceProviderAPI } from "../../../apis/serviceProviderAPI";
import BkgImage from "../../../assets/bkg.png";
import { languageContent as content } from "../../../components/Language/languageContent";
import { LanguageContext } from "../../../components/Language/LanguageContext";

const DetailServiceProvider = () => {
  // Scroll to the detail section when the component is rendered
  useEffect(() => {
    document
      .getElementById("detail-section")
      .scrollIntoView({ behavior: "smooth" });
  }, []);
  const navigate = useNavigate();
  const { id, typeOfServiceProvider } = useParams();
  //Language
  const { language } = useContext(LanguageContext);
  const {
    homeTutorsList,
    nanniesList,
    ID,
    homeTutorInfo,
    nannyInfo,
    nameContent,
    placeContent,
    typeofServiceContent,
    priceContent,
    brHour,
    brMonth,
    ageContent,
    languageContent,
    yearOfExperienceContent,
    aboutMeContent,
    majorContent,
    educationContent,
    levelContent,
    subjectContent,
    hobbyContent,
    backToListView,
    bookNanny,
    bookHomeTutor,
  } = content[language];
  const { Title } = Typography;

  const [serviceProviderList, setServiceProviderList] = useState(undefined);

  const text = getTextOfServiceProvider(typeOfServiceProvider);
  console.log(`useParams() in DetailServiceProvider.js`, JSON.stringify(useParams()))

  useEffect(() => {
    console.log(`DetailServiceProvider.js`)
    ServiceProviderAPI.get(typeOfServiceProvider, id)
      .then((response) => {
        setServiceProviderList(response);
      })
      .catch((error) => {
        console.error(error);
        setServiceProviderList(false);
      });
  }, [id, typeOfServiceProvider]);

  const {
    firstName,
    middleName,
    lastName,
    place,
    typeOfService,
    pricePerMonth,
    yearOfBirth,
    isCertified,
    aboutMe,
    profilePhotoUrl,
    yearOfExperience,
    dateTimePreference,
    averageRating,

    //nanny details
    languages,
    ageGroups,

    // cook clear details
    breakfast,
    lunchDinner,
    habeshaBreakfast,
    habeshaLunchDinner,

    // home tutor details
    major,
    education,
    hobbies,
    levels,
    subjects,
  } = serviceProviderList || {}; // Use an empty object as a fallback
  const fullName = constructFullName(firstName, middleName, lastName);

  return (
    <div
      id="detail-section"

      // style={{paddingLeft: "1px", paddingRight: "1px", paddingTop: "20px"}}
    >
      {serviceProviderList === undefined && (
        <div className="parent-div">
          <div className="child-div">
            <div
              className="w-full py-[10rem] px-4 bg-white"
              style={{
                backgroundImage: `url(${BkgImage})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                minHeight: "100vh", // Ensure the div takes up the full height of the viewport
              }}
            >
              <Progress type="circle" />
            </div>
          </div>
        </div>
      )}
      {serviceProviderList !== undefined && serviceProviderList && (
        <>
          <div className="parent-div">
            <div className="child-div">
              <div
                className="w-full py-[10rem] px-4 bg-white"
                style={{
                  backgroundImage: `url(${BkgImage})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  minHeight: "100vh", // Ensure the div takes up the full height of the viewport
                }}
              >
                <div className="max-w-[1240px] mx-auto grid md:grid-cols-1 gap-8">
                  <Breadcrumb>
                    <Breadcrumb.Item key="home">Mogzit.com</Breadcrumb.Item>
                    <Breadcrumb.Item key="list">
                      <Link to="/">
                        {text.listViewText === "List Nannies"
                          ? nanniesList
                          : homeTutorsList}
                      </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item key="detail">
                      <Link
                        to={`/serviceProviderList/${serviceProviderList.id}`}
                      >
                        <span className="text-[#c90254] font-bold">
                          {text.detailViewText === "Nanny Info"
                            ? nannyInfo
                            : homeTutorInfo}
                        </span>
                      </Link>
                    </Breadcrumb.Item>
                  </Breadcrumb>

                  <Title
                    level={3}
                    style={{
                      marginTop: "10px",
                      color: "#c90254",
                      fontFamily: "Sora",
                    }}
                  >
                    {text.title === "Nanny Info" ? nannyInfo : homeTutorInfo}
                  </Title>

                  <Row gutter={[48, 16]}>
                    <Col
                      //span={4}
                      type="flex"
                      align="center"
                      style={{ marginTop: "20px", marginRight: "20px" }}
                      xs={{ span: 24 }}
                      sm={{ span: 12 }}
                      md={{ span: 8 }}
                      lg={{ span: 4 }}
                    >
                      <Image
                        src={profilePhotoUrl}
                        width="200px"
                        fallback="data:image/png;base64,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"
                      />
                      <Rate
                        disabled
                        allowHalf
                        value={averageRating}
                        style={{ fontSize: 16 }}
                      />
                    </Col>

                    <Col
                      span={18}
                      style={{ marginTop: "20px", marginLeft: "20px" }}
                    >
                      <Descriptions>
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold  sora">
                              {ID}
                            </span>
                          }
                        >
                          {getNameInitials(fullName)}
                          {id}
                        </Descriptions.Item>
                        {/*<Descriptions.Item label="Full Name">{fullName}</Descriptions.Item>*/}
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold  sora">
                              {nameContent}
                            </span>
                          }
                        >
                          {toFirstCharUpperCase(firstName)}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold  sora">
                              {placeContent}
                            </span>
                          }
                        >
                          {place}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold sora">
                              {typeofServiceContent}
                            </span>
                          }
                        >
                          <span className="sora">{typeOfService}</span>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold sora">
                              {priceContent}
                            </span>
                          }
                        >
                          {" "}
                          <span className="sora">
                            {pricePerMonth}{" "}
                            {typeOfServiceProvider === "homeTutor"
                              ? brHour
                              : brMonth}
                          </span>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold sora">
                              {ageContent}
                            </span>
                          }
                        >
                          {" "}
                          <span className="sora">
                            {ageCalculator(yearOfBirth)}
                          </span>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold sora">
                              {languageContent}
                            </span>
                          }
                        >
                          <span className="sora">{languages}</span>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="text-[#c90254] font-bold sora">
                              {yearOfExperienceContent}
                            </span>
                          }
                        >
                          {yearOfExperience ? yearOfExperience : "-"}
                        </Descriptions.Item>

                        <div className="flex flex-col sm:flex-row">
                          <div className="mb-2 sm:mb-0 sm:mr-0.1 font-bold text-[#c90254]">
                            Date/Time Preference
                          </div>
                          <div>{dateTimePreference}</div>
                        </div>
                      </Descriptions>

                      {typeOfServiceProvider === "nanny" && (
                        <Fragment>
                          <Descriptions>
                            <Descriptions.Item
                              label={
                                <span className="text-[#c90254] font-bold sora">
                                  Is Certified?
                                </span>
                              }
                            >
                              {isCertified ? "Certified" : "Not Certified"}
                            </Descriptions.Item>

                            <Descriptions.Item
                              label={
                                <span className="text-[#c90254] font-bold  sora">
                                  Age Groups
                                </span>
                              }
                            >
                              {ageGroups.join(", ")}
                            </Descriptions.Item>
                          </Descriptions>
                        </Fragment>
                      )}

                      {(typeOfServiceProvider === "nanny" ||
                        typeOfServiceProvider === "homeTutor") && (
                        <Fragment>
                          <p>
                            <strong className="text-[#c90254] font-bold  sora">
                              {aboutMeContent}:
                            </strong>{" "}
                            <span className="sora">{aboutMe}</span>
                          </p>
                        </Fragment>
                      )}

                      {typeOfServiceProvider === "cookCleaner" && (
                      <Fragment>
                        <Title level={5}>
                          What international cuisine can you cook?
                        </Title>
                        <Descriptions>
                          <Descriptions.Item label={"Breakfast"}>
                            {breakfast}
                          </Descriptions.Item>
                        </Descriptions>
                        <Descriptions>
                          <Descriptions.Item label={"Lunch and Dinner"}>
                            {lunchDinner}
                          </Descriptions.Item>
                        </Descriptions>

                        <Title level={5}>
                          What Ethiopian food can you cook?
                        </Title>
                        <Descriptions>
                          <Descriptions.Item label={"Habesha Breakfast"}>
                            {habeshaBreakfast}
                          </Descriptions.Item>
                        </Descriptions>
                        <Descriptions>
                          <Descriptions.Item label={"Habesha Lunch and Dinner"}>
                            {habeshaLunchDinner}
                          </Descriptions.Item>
                        </Descriptions>
                      </Fragment>
                    )}

                      {typeOfServiceProvider === "homeTutor" && (
                        <Descriptions>
                          <Descriptions.Item
                            label={
                              <span className="text-[#c90254] font-bold sora">
                                {majorContent}
                              </span>
                            }
                          >
                            {major}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={
                              <span className="text-[#c90254] font-bold sora">
                                {educationContent}
                              </span>
                            }
                          >
                            {education}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={
                              <span className="text-[#c90254] font-bold sora">
                                {levelContent}
                              </span>
                            }
                          >
                            {levels.join(", ")}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={
                              <span className="text-[#c90254] font-bold sora">
                                {subjectContent}
                              </span>
                            }
                          >
                            {subjects.join(", ")}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={
                              <span className="text-[#c90254] font-bold">
                                {hobbyContent}
                              </span>
                            }
                          >
                            {hobbies}
                          </Descriptions.Item>
                        </Descriptions>
                      )}
                    </Col>
                  </Row>
                </div>
                <div className={"ant-layout-content"}>
                  {serviceProviderList !== undefined && (
                    <Row type="flex" align="center" style={{ margin: "20px" }}>
                      <Button
                        onClick={() =>
                          navigate(`/${typeOfServiceProvider}`)
                        }
                        type="primary"
                        size="large"
                        className="pink-button sora"
                        style={{ marginRight: "10px", marginBottom: "8px" }}
                      >
                        {backToListView}
                      </Button>
                      <Button
                        type="primary"
                        size="large"
                        className="pink-button sora"
                        onClick={() =>
                          navigate(
                            `/book/${typeOfServiceProvider}/${serviceProviderList.id}`
                          )
                        }
                      >
                        {text.bookLabel === "Book Home Tutor"
                          ? bookHomeTutor
                          : bookNanny}
                      </Button>
                    </Row>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {serviceProviderList === false && (
        <Typography>{text.notFound}</Typography>
      )}
    </div>
  );
};

export default DetailServiceProvider;
